var _rect, _path, _path2, _path3, _path4, _defs;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWhatsappLarge = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_1213_24024)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 18L7.34814 14.9202C6.82378 14.0162 6.54871 12.9924 6.55158 11.9458C6.55158 8.66635 9.23352 6 12.5258 6C14.1246 6 15.6261 6.61882 16.7521 7.7424C17.8811 8.86597 18.5029 10.3603 18.5 11.9487C18.5 15.2281 15.818 17.8945 12.5229 17.8945H12.5201C11.5201 17.8945 10.5372 17.6435 9.66332 17.1702L6.5 18ZM9.81518 16.0951L9.9957 16.2034C10.7579 16.654 11.6318 16.8907 12.5229 16.8935H12.5258C15.2622 16.8935 17.4914 14.6778 17.4914 11.9515C17.4914 10.6312 16.9756 9.39068 16.0387 8.45532C15.1017 7.51996 13.8524 7.00665 12.5258 7.00665C9.7894 7.0038 7.56017 9.21958 7.56017 11.9458C7.56017 12.8783 7.82092 13.788 8.31948 14.5751L8.43696 14.7633L7.93553 16.5856L9.81518 16.0951Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70923 17.7918L7.52871 14.8175C7.02155 13.9477 6.75507 12.9582 6.75507 11.9487C6.75794 8.78329 9.34533 6.20819 12.5258 6.20819C14.0703 6.20819 15.5172 6.80705 16.6061 7.8907C17.6949 8.97435 18.2937 10.4173 18.2937 11.9515C18.2937 15.1169 15.7035 17.692 12.5258 17.692H12.523C11.5574 17.692 10.6089 17.4496 9.76653 16.9934L6.70923 17.7918Z",
    fill: "url(#paint1_linear_1213_24024)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 18L7.34814 14.9202C6.82378 14.0162 6.54871 12.9924 6.55158 11.9458C6.55158 8.66635 9.23352 6 12.5258 6C14.1246 6 15.6261 6.61882 16.7521 7.7424C17.8811 8.86597 18.5029 10.3603 18.5 11.9487C18.5 15.2281 15.818 17.8945 12.5229 17.8945H12.5201C11.5201 17.8945 10.5372 17.6435 9.66332 17.1702L6.5 18ZM9.81518 16.0951L9.9957 16.2034C10.7579 16.654 11.6318 16.8907 12.5229 16.8935H12.5258C15.2622 16.8935 17.4914 14.6778 17.4914 11.9515C17.4914 10.6312 16.9756 9.39068 16.0387 8.45532C15.1017 7.51996 13.8524 7.00665 12.5258 7.00665C9.7894 7.0038 7.56017 9.21958 7.56017 11.9458C7.56017 12.8783 7.82092 13.788 8.31948 14.5751L8.43696 14.7633L7.93553 16.5856L9.81518 16.0951Z",
    fill: "url(#paint2_linear_1213_24024)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0329 9.45915C10.9211 9.21105 10.8037 9.20535 10.6976 9.2025C10.6117 9.19965 10.5114 9.19965 10.4111 9.19965C10.3108 9.19965 10.1504 9.23672 10.0128 9.38501C9.87529 9.5333 9.49133 9.89261 9.49133 10.6255C9.49133 11.3555 10.0271 12.0628 10.1016 12.1626C10.1761 12.2624 11.136 13.8109 12.6518 14.4069C13.9125 14.9031 14.1704 14.8033 14.4426 14.7776C14.7148 14.7519 15.3251 14.4183 15.4512 14.0704C15.5744 13.7225 15.5744 13.4259 15.5372 13.3631C15.4999 13.3004 15.3996 13.2633 15.2506 13.1892C15.1016 13.115 14.3681 12.7557 14.2306 12.7044C14.093 12.6559 13.9928 12.6303 13.8953 12.7785C13.7951 12.9268 13.5085 13.2605 13.4226 13.3603C13.3366 13.4601 13.2478 13.4715 13.0988 13.3974C12.9498 13.3232 12.4684 13.1664 11.8982 12.6588C11.4541 12.2652 11.1532 11.7776 11.0673 11.6293C10.9813 11.481 11.0587 11.4012 11.1332 11.327C11.1991 11.2614 11.2822 11.1531 11.3567 11.0675C11.4312 10.982 11.4569 10.9192 11.5057 10.8194C11.5544 10.7196 11.5314 10.6341 11.4942 10.5599C11.4569 10.4886 11.1647 9.75288 11.0329 9.45915Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1213_24024",
    x1: 12.4994,
    y1: 23.9988,
    x2: 12.4994,
    y2: -0.000839698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1213_24024",
    x1: 12.5012,
    y1: 17.7913,
    x2: 12.5012,
    y2: 6.20779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1213_24024",
    x1: 12.5012,
    y1: 17.9989,
    x2: 12.5012,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWhatsappLarge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/whatsapp-large.24375f90.svg";
export { ForwardRef as ReactComponent };